import { render, staticRenderFns } from "./audioplay.vue?vue&type=template&id=2462472e&scoped=true&"
import script from "./audioplay.vue?vue&type=script&lang=js&"
export * from "./audioplay.vue?vue&type=script&lang=js&"
import style0 from "./audioplay.vue?vue&type=style&index=0&id=2462472e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2462472e",
  null
  
)

export default component.exports